import React from 'react'
import BaseInput from '../BaseInput'

EmailInput.propTypes = BaseInput.propTypes

export default function EmailInput(baseInputProps) {
  return <BaseInput type="email" {...baseInputProps} />
}
